export default "__VITE_ASSET__689b822d__"